import { lazy, Suspense } from 'react'

import { cx } from 'styled-system/css'
import { Box, BoxProps } from 'styled-system/jsx'

import classes from './JsonViewer.module.css'

const ReactJsonView = lazy(() => import('@microlink/react-json-view'))

export function JsonViewer({
  json,
  collapsed = false,
  className,
  ...props
}: {
  json?: any
  collapsed?: boolean | number
} & BoxProps) {
  if (json === null || json === undefined) {
    return '<empty data>'
  }

  if (typeof json !== 'object') {
    return json.toString()
  }

  return (
    <Box {...props} className={cx(classes.json_viewer, className)}>
      <Suspense fallback={<div>Loading...</div>}>
        <ReactJsonView
          name={null} // disable root name
          iconStyle='square'
          displayDataTypes={false}
          displayObjectSize={false}
          quotesOnKeys={false}
          theme='rjv-default'
          src={json ?? {}}
          collapsed={collapsed}
          shouldCollapse={({ namespace, src, type }) => {
            const tooDeep = namespace.length > 2 // collapse at depth 3
            const tooManyItems = type === 'array' && (src as any[]).length > 20 // collapse arrays with more than 20 items

            return tooDeep || tooManyItems
          }}
        />
      </Suspense>
    </Box>
  )
}
